import { createSignal } from 'solid-js'

const [account, setAccount] = createSignal(window.user ?? {})

export default account

export function logout() {
  setAccount({})
}

export function keepalive() {
  if (account().username) {
    fetch('/api/keepalive')
  }
  setTimeout(() => keepalive(), 60_000)
}
